import { APPENDIX_LABEL_PREFIX, APPENDIX_SECTION_NUMBER_PATTERN } from "constants/constants";

/** True when the section number is the number of a whole appendix ("D"), not of a numbered section. */
export const isAppendixSectionNumber = (sectionNumber?: string | null): boolean =>
	APPENDIX_SECTION_NUMBER_PATTERN.test(sectionNumber ?? "");

/** "Appendix D" for a whole appendix, "§ 507.5.1" for any other section. */
export const formatSectionNumberForCitation = (sectionNumber: string): string =>
	isAppendixSectionNumber(sectionNumber) ? `${APPENDIX_LABEL_PREFIX} ${sectionNumber}` : `§ ${sectionNumber}`;
